import manifest from './siteImageManifest.js';

// Faster copies of the images the site draws (scripts/site-images/sync_site_images.py):
// - NIKKE portraits: WebP copies in our own public repo (kukla1255/doroparty-assets), served by
//   jsDelivr pinned to one commit, so they stay cached for a year. They are not served from the site
//   itself: Korean visitors reach it through Cloudflare's Hong Kong or Tokyo edge, which measured
//   ~35x slower for a screen of portraits than jsDelivr answering from Seoul.
// - Boss art: a WebP copy in the site's static assets, a fraction of the original PNG's size.
// The data keeps the original URL everywhere, so nothing that saves a boss or a NIKKE back to the
// database can write one of these into it; only the code that draws an image swaps it here. An image
// added after the last sync keeps its original URL until the next one.

const text = (value) => String(value ?? '').trim();

export function siteImageUrl(url) {
  const source = text(url);
  return (source && manifest[source]) || source;
}

// Faster copy first, then the original, for components that can fall back on a load error.
export function siteImageCandidates(url) {
  const source = text(url);
  if (!source) return [];
  const faster = manifest[source];
  return faster ? [faster, source] : [source];
}
